<template>
  <div class="n2-pagina" ref="raiz">
    <N2CabezaPagina :titulo="titulo" :subtitulo="P.Subtitulo?.Texto" :imagen="P.Imagen" :filtro="P.ImagenFiltro"
      :boton="P.ShowButton ? P.Button : null" />

    <section class="n2-seccion n2-seccion--pagina">
      <div class="n2-contenedor">
        <!-- Panel: Galería, las imágenes marcadas "Mostrar en la galería", en su orden -->
        <div class="n2-galeria" :class="{ 'n2-lista--una': columnas === 1 }" :style="{ '--n2-columnas': columnas }">
          <figure v-for="(f, i) in fotos" :key="f.id" class="n2-galeria__foto n2-aparece">
            <button type="button" @click="indice = i; abierta = true" :aria-label="f.Description || ('Imagen ' + (i + 1))">
              <img :src="imagenIDtoSRC(f.id)" :alt="f.Description || ('Imagen ' + (i + 1) + ' - ' + NOTARIA.Nombre)" loading="lazy" />
            </button>
            <figcaption v-if="P.ShowDescriptions && f.Description" v-html="conSaltos(f.Description)"></figcaption>
          </figure>
        </div>
      </div>
    </section>
    <GalleryLightbox v-model="abierta" :images="fotos.map(f => ({ src: imagenIDtoSRC(f.id) }))" :initialIndex="indice" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { tituloSeccion, conSaltos, columnasPanel, useAparicion } from '../../composables/useNotaria2'
import N2CabezaPagina from './N2CabezaPagina.vue'

const store = useStore()
const { NOTARIA, ARCHIVOS_COMUNES } = storeToRefs(store)
const { imagenIDtoSRC, $t } = useUtils()
const raiz = ref(null)
useAparicion(raiz)
const abierta = ref(false)
const indice = ref(0)

// Panel: Diseño páginas → Galería (cabecera, columnas y descripciones)
const P = computed(() => NOTARIA.value?.Theme?.Gallery ?? {})
const titulo = computed(() => P.value.Titulo?.Texto || tituloSeccion(NOTARIA.value, 'Gallery', $t))
const columnas = computed(() => columnasPanel(P.value.NumeroColumnas))
const fotos = computed(() => {
  const origen = ARCHIVOS_COMUNES.value?.length ? ARCHIVOS_COMUNES.value : (NOTARIA.value?.Archivos ?? [])
  return origen.filter(a => a.id && a.showInGallery).sort((a, b) => (Number(a.Orden) || 9999) - (Number(b.Orden) || 9999))
})
</script>
